export enum GameThemeId {
    Adventure = 1,
    AncientCivilization = 2,
    Wildlife = 3,
    ClassicStyle = 4,
    Asian = 5,
    TableGames = 7,
    MoviesAndMusic = 8,
    Fruit = 12,
    MoneyAndLeisure = 15,
    ComicsAndCartoons = 16,
    Irish = 19,
    Arcade = 25,
    DiamondsAndGems = 26,
    FantasyAndFolklore = 28,
    Seasonal = 29,
    Egyptian = 30,
    FarmAndPets = 35,
    Sports = 47,
    LiveCasino = 54,
    Arabic = 58,
    GreekMythology = 63,
    NA = 64,
    SpaceAndSciFi = 72,
    ScratchCards = 76,
    Fish = 77,
    Mexican = 82,
    Xmas = 93,
    Bingo = 94,
    ClassicStyleModernized = 95,
    AztecIncaMayan = 96,
    Crime = 97,
    WildWest = 98,
    CandyAndSweets = 99,
    GoldMining = 100,
    VikingsAndNordicMythology = 101,
  }